import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { calculatePositions } from 'utils/redux'
import { listSelector } from '../selectors/list'
import {
  addCardToList,
  removeCardFromList
} from '../redux/lists'
import {
  setPositions,
  set as setCard
} from '../redux/cards'

export default function * requestPositionCard (action) {
  const { id, listId, position } = action.payload

  let currentListId = null

  const state = yield select()

  const card = state['view-myboard'].cards[id]

  if (!card) return

  const lists = state['view-myboard'].lists
  const listIds = Object.keys(lists)
  for (let i = 0, length = listIds.length; i < length; i++) {
    const list = lists[listIds[i]]
    if (list.cards.indexOf(id) !== -1) {
      currentListId = list.id
      break
    }
  }

  if (!currentListId) return

  const cardsById = state['view-myboard'].cards
  const cards = listSelector(state, { id: listId }).cards.map(cardId => cardsById[cardId])

  if (listId === currentListId) {
    const optimisticAction = yield optimisticPut(setPositions(calculatePositions({
      array: cards,
      id,
      position
    })))  

    try {
      yield call(apiAction, 'PositionVCard', {
        id,
        position
      })
    } finally {
      yield optimisticAction.revert()
    }
  } else {
    const optimisticAction = yield optimisticPut([
      removeCardFromList({
        listId: currentListId,
        cardId: id
      }),
      addCardToList({
        listId,
        cardId: id
      }),
      setPositions(calculatePositions({
        array: cards,
        id,
        position
      }))
    ])

    try {
      yield call(apiAction, 'ChangeVCardParent', {
        containerFromId: currentListId,
        containerToId: listId,
        id,
        position
      })
    } finally {
      yield optimisticAction.revert()
    }
  }
}
